const formatTimestamp = (timestamp: string) => {
  const dateObj = new Date(timestamp);

  const day = dateObj.getDate().toString().padStart(2, '0');
  const month = dateObj
    .toLocaleDateString(undefined, { month: 'short' })
    .toUpperCase()
    .replace('.', '');
  const year = dateObj.getFullYear();
  const formattedDate = `${day} ${month} ${year}`;

  const hours24 = dateObj.getHours();
  const is12HourFormat = dateObj
    .toLocaleTimeString(undefined, { hour: 'numeric' })
    .includes('M');

  const hours = is12HourFormat
    ? (hours24 % 12 || 12).toString().padStart(2, '0')
    : hours24.toString().padStart(2, '0');
  const minutes = dateObj.getMinutes().toString().padStart(2, '0');
  const seconds = dateObj.getSeconds().toString().padStart(2, '0');
  const milliseconds = dateObj.getMilliseconds().toString().padStart(4, '0');
  let period = '';
  if (is12HourFormat) {
    period = hours24 >= 12 ? ' PM' : ' AM';
  }
  const formattedTime = `${hours}:${minutes}:${seconds}:${milliseconds}${period}`;

  return { formattedDate, formattedTime };
};

export default formatTimestamp;
